<script lang="ts" setup>
const props = defineProps({
  company: {
    default: undefined,
    type: Object as PropType<CompanyV2>,
  },
  freeRequest: {
    default: false,
    type: Boolean,
  },
  max: {
    default: Number.POSITIVE_INFINITY,
    type: Number,
  },
  size: {
    default: 'sm',
    type: String as PropType<UBadgeSize | UButtonSize>,
  },
  wrap: {
    default: true,
    type: Boolean,
  },
})

const { getCompaniesSearchUrl } = useSegmentation()
const { t } = useI18n()

const badges = computed((): UBadge[] => {
  const industries = [...props.company?.about?.industries || []]

  // Add main industry if not present
  if (props.company?.about?.industry) {
    industries.unshift(props.company?.about?.industry)
  }

  return industries
    // Format badges
    .map((industry) => {
      return {
        color: (industry === props.company?.about?.industry ? 'violet' : 'indigo') as UBadgeColor,
        label: changeCase.noCase(industry),
        to: getCompaniesSearchUrl({
          attribute: 'about.industries',
          value: industry,
        }),
        tooltip: industry === props.company?.about?.industry
          ? t('datapoints.attributes.about-industry')
          : t('datapoints.attributes.about-industries'),
      }
    })
    .filter((industry, industryIndex, industries) => {
      return industries.findIndex(otherIndustry => otherIndustry.label === industry.label) === industryIndex
    })
    .sort((industry) => {
      return industry.color === 'violet' ? -1 : 0
    })
})
</script>

<template>
  <div class="flex gap-2">
    <BaseBadges
      :badges="badges"
      clickable
      :max="max"
      :size="size"
      variant="subtle"
      :wrap="wrap"
    />

    <CompaniesSimplifiedPlaceholder
      v-if="freeRequest"
      attribute="about.industries"
      :company="company"
    />
  </div>
</template>
